import { connect } from "react-redux";
import SurveyStepSimulation from "./SurveyStepSimulation";
import _ from "lodash";
import {
	setGenerated,
	resetPagination,
} from "./../../../../redux/actions/surveyActions";

const mapStateToProps = (state, ownProps) => {
	return {
		//currentSurvey: state.survey.surveyManager.currentSurvey,
		//currentSurvey: state.survey.surveyManager.surveyProgress,
		isSurveyGenerated: state.survey.simulationManager.isSurveyGenerated,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		setGenerated: generated => {
			dispatch(setGenerated(generated));
		},
		resetSimulationPagination: () => {
			dispatch(resetPagination());
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SurveyStepSimulation);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSimulation/SurveyStepSimulationContainer.js